/**
 * Map failed font upload Response to a short user message (nginx often returns HTML for 413).
 */
function isNoiseRestMessage(msg: string): boolean {
  const s = msg.trim();
  return /^HTTP\s*\d{3}$/i.test(s) || /^Upload failed:\s*\d{3}$/i.test(s);
}

export async function throwIfReportFontUploadFailed(
  res: Response,
  t: (msg: string) => string,
): Promise<void> {
  if (res.ok) {
    return;
  }
  const status = res.status;
  if (status === 413) {
    throw new Error(
      t(
        'Ce fichier est trop volumineux pour le serveur. Réessayez avec un fichier plus petit ou une police statique / WOFF.',
      ),
    );
  }
  const ct = res.headers.get('content-type') ?? '';
  if (ct.includes('application/json')) {
    const body = (await res.json().catch(() => null)) as { message?: string } | null;
    const msg = body?.message?.trim();
    if (msg && !/<\s*html[\s>]/i.test(msg) && !isNoiseRestMessage(msg)) {
      throw new Error(msg);
    }
  }
  if (status === 403) {
    throw new Error(t("Vous n'avez pas la permission d'envoyer ce fichier."));
  }
  throw new Error(t('Le téléversement a échoué.') + (status ? ` (${status})` : ''));
}
